import React from "react";

/**
 * BgOrbs — ambient animated gradient orbs for section backgrounds.
 *
 * Variants pair nicely with each section's mood; keep them behind content:
 * the parent section MUST be `position: relative` and `overflow: hidden`.
 *
 * Usage:
 *   <BgOrbs variant="blue" />     // Benefits-ish, cool blue/indigo
 *   <BgOrbs variant="teal" />     // Analytics, teal/blue
 *   <BgOrbs variant="violet" />   // UseCases / Impact, violet/pink
 *   <BgOrbs variant="amber" />    // Testimonials, warm amber/rose
 *   <BgOrbs variant="sky" />      // FAQ, airy sky/blue
 */
const PALETTES = {
  blue: [
    "radial-gradient(circle, rgba(59,130,246,0.35), transparent 70%)",
    "radial-gradient(circle, rgba(99,102,241,0.30), transparent 70%)",
    "radial-gradient(circle, rgba(14,165,233,0.20), transparent 70%)",
  ],
  teal: [
    "radial-gradient(circle, rgba(20,184,166,0.35), transparent 70%)",
    "radial-gradient(circle, rgba(59,130,246,0.28), transparent 70%)",
    "radial-gradient(circle, rgba(16,185,129,0.22), transparent 70%)",
  ],
  violet: [
    "radial-gradient(circle, rgba(139,92,246,0.38), transparent 70%)",
    "radial-gradient(circle, rgba(236,72,153,0.28), transparent 70%)",
    "radial-gradient(circle, rgba(99,102,241,0.22), transparent 70%)",
  ],
  amber: [
    "radial-gradient(circle, rgba(245,158,11,0.32), transparent 70%)",
    "radial-gradient(circle, rgba(244,63,94,0.28), transparent 70%)",
    "radial-gradient(circle, rgba(251,113,133,0.22), transparent 70%)",
  ],
  sky: [
    "radial-gradient(circle, rgba(56,189,248,0.32), transparent 70%)",
    "radial-gradient(circle, rgba(59,130,246,0.26), transparent 70%)",
    "radial-gradient(circle, rgba(167,139,250,0.22), transparent 70%)",
  ],
};

export default function BgOrbs({ variant = "violet" }) {
  const [a, b, c] = PALETTES[variant] || PALETTES.violet;
  return (
    <div
      aria-hidden
      className="absolute inset-0 overflow-hidden pointer-events-none"
      data-testid={`bg-orbs-${variant}`}
    >
      <div
        className="bg-orb bg-orb--a"
        style={{
          width: 560,
          height: 560,
          top: "-10%",
          left: "-12%",
          background: a,
        }}
      />
      <div
        className="bg-orb bg-orb--b"
        style={{
          width: 620,
          height: 620,
          bottom: "-18%",
          right: "-14%",
          background: b,
        }}
      />
      <div
        className="bg-orb bg-orb--c"
        style={{
          width: 380,
          height: 380,
          top: "40%",
          left: "55%",
          background: c,
          opacity: 0.5,
        }}
      />
    </div>
  );
}
